// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE
// inspired by javascript-hint.js in codemirror.net

/* Example definition of a simple mode that understands a subset of
 * JavaScript:
 */

// eslint declarations
/* global stringProps: true, arrayProps: true, funcProps: true */

import CodeMirror from 'codemirror';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/mode/simple';
// Styles
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/hint/show-hint.css';

var mathJsKeywords = ("boolean chain complex createUnit fraction number string unit derivative abs add cbrt ceil cube divide dotDivide dotMultiply dotPow exp fix floor gcd hypot lcm log log10 mod multiply norm nthRoot pow round sign sqrt square subtract unaryMinus unaryPlus xgcd bitAnd bitNot bitOr bitXor bellNumbers catalan composition distance intersect and not or xor contact cross det diag dot eye filter inv kron map combinations factorial gamma permutations pickRandom random compare deepEqual equal larger largerEq smaller smallerEq unequal mad max mean median min mode prod std sum var format acos acosh acot acoth acsc ascsh asec asech asin asinh atan atan2 atanh cos cosh cot coth csc sec sech sin sinh tan tanh to clone isInteger isNaN isNegative isPositive isPrime isNumeric isZero typeof").split(" ");

// To adjust CodeMirror syntax highlighting for Attribute formulas #1724...
var tuvaDisallowedKeywords = ["std","mad"]; // these are similar to Aggregate.functions() but don't work correctly; remove them
var tuvaNewKeywords = ["length","mean", "median", "iqr", "stdDev", "meanAvDev", "variance", "sum", "min", "max", "count"]; // see Aggregate.functions()
function tuvaModifyKeywords() {
    let keywords = mathJsKeywords.filter( k => ! tuvaDisallowedKeywords.includes(k)); // remove disallowed keywords
    keywords = [...keywords, ...tuvaNewKeywords]; // add new keywords
    return [...new Set([...keywords])]; // remove duplicates
}

CodeMirror.defineSimpleMode("mathjs", {
  // The start state contains the rules that are intially used
  start: [
    // The regex matches the token, the token property contains the type
    {regex: /"(?:[^\\]|\\.)*?(?:"|$)/, token: "string"},
    // You can match multiple tokens at once. Note that the captured
    // groups must span the whole string in this case
    {regex: /(function)(\s+)([a-z$][\w$]*)/,
     token: ["keyword", null, "variable-2"]},
    // Rules are matched in the order in which they appear, so there is
    // no ambiguity between this one and the one above
    // {regex: /(?:sin|cos|log)\b/, token: "keyword"},
    {token: "keyword", regex: "\\b(?:" + tuvaModifyKeywords( mathJsKeywords ).join("|") + ")\\b"},
    // {regex: /true|false|null|undefined/, token: "atom"},
    {regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
     token: "number"},
    {regex: /\/\/.*/, token: "comment"},
    {regex: /\/(?:[^\\]|\\.)*?\//, token: "variable-3"},
    // A next property will cause the mode to move to a different state
    {regex: /\/\*/, token: "comment", next: "comment"},
    {regex: /[-+\/*=<>!]+/, token: "operator"},
    // indent and dedent properties guide autoindentation
    {regex: /[\{\[\(]/, indent: true},
    {regex: /[\}\]\)]/, dedent: true},
    {regex: /[a-z$][\w$]*/, token: "variable"},
    // You can embed other modes with the mode property. This rule
    // causes all code between << and >> to be highlighted with the XML
    // mode.
    {regex: /<</, token: "meta", mode: {spec: "xml", end: />>/}}
  ],
  // The multi-line comment state.
  comment: [
    {regex: /.*?\*\//, token: "comment", next: "start"},
    {regex: /.*/, token: "comment"}
  ],
  // The meta property contains global information about the mode. It
  // can contain properties like lineComment, which are supported by
  // all modes, and also directives like dontIndentStates, which are
  // specific to simple modes.
  meta: {
    dontIndentStates: ["comment"],
    lineComment: "//"
  }
});

// hint code
var Pos = CodeMirror.Pos;

function forEach(arr, f) {
  for (var i = 0, e = arr.length; i < e; ++i) f(arr[i]);
}

function arrayContains(arr, item) {
  if (!Array.prototype.indexOf) {
    var i = arr.length;
    while (i--) {
      if (arr[i] === item) {
        return true;
      }
    }
    return false;
  }
  return arr.indexOf(item) != -1;
}

function scriptHint(editor, keywords, getToken, options) {
  // Find the token at the cursor
  var cur = editor.getCursor(), token = getToken(editor, cur);
  if (/\b(?:string|comment)\b/.test(token.type)) return;
  token.state = CodeMirror.innerMode(editor.getMode(), token.state).state;

  // If it's not a 'word-style' token, ignore the token.
  if (!/^[\w$_]*$/.test(token.string)) {
    token = {start: cur.ch, end: cur.ch, string: "", state: token.state,
             type: token.string == "." ? "property" : null};
  } else if (token.end > cur.ch) {
    token.end = cur.ch;
    token.string = token.string.slice(0, cur.ch - token.start);
  }

  var tprop = token;
  // If it is a property, find out what it is a property of.
  while (tprop.type == "property") {
    tprop = getToken(editor, Pos(cur.line, tprop.start));
    if (tprop.string != ".") return;
    tprop = getToken(editor, Pos(cur.line, tprop.start));
    if (!context) var context = [];
    context.push(tprop);
  }
  return {list: getCompletions(token, context, keywords, options),
          from: Pos(cur.line, token.start),
          to: Pos(cur.line, token.end)};
}

function mathJSHint(editor, options) {
  return scriptHint(editor, mathJsKeywords,
    function (e, cur) {return e.getTokenAt(cur);},
      options);
};
CodeMirror.registerHelper("hint", "mathjs", mathJSHint);

function forAllProps(obj, callback) {
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
    for (var name in obj) callback(name)
  } else {
    for (var o = obj; o; o = Object.getPrototypeOf(o))
      Object.getOwnPropertyNames(o).forEach(callback)
  }
}

function getCompletions(token, context, keywords, options) {
  var found = [], start = token.string, global = options && options.globalScope || {};
  function maybeAdd(str) {
    if (str.lastIndexOf(start, 0) == 0 && !arrayContains(found, str)) found.push(str);
  }
  function gatherCompletions(obj) {
    if (typeof obj == "string") forEach(stringProps, maybeAdd);
    else if (obj instanceof Array) forEach(arrayProps, maybeAdd);
    else if (obj instanceof Function) forEach(funcProps, maybeAdd);
    forAllProps(obj, maybeAdd)
  }

  if (context && context.length) {
    // If this is a property, see if it belongs to some object we can
    // find in the current environment.
    var obj = context.pop(), base;
    if (obj.type && obj.type.indexOf("variable") === 0) {
      if (options && options.additionalContext)
        base = options.additionalContext[obj.string];
      if (!options || options.useGlobalScope !== false)
        base = base || global[obj.string];
    } else if (obj.type == "string") {
      base = "";
    } else if (obj.type == "atom") {
      base = 1;
    } else if (obj.type == "function") {
      if (global.jQuery != null && (obj.string == '$' || obj.string == 'jQuery') &&
          (typeof global.jQuery == 'function'))
        base = global.jQuery();
      else if (global._ != null && (obj.string == '_') && (typeof global._ == 'function'))
        base = global._();
    }
    while (base != null && context.length)
      base = base[context.pop().string];
    if (base != null) gatherCompletions(base);
  } else {
    // If not, just look in the global object and any local scope
    // (reading into JS mode internals to get at the local and global variables)
    for (var v = token.state.localVars; v; v = v.next) maybeAdd(v.name);
    for (var v = token.state.globalVars; v; v = v.next) maybeAdd(v.name);
    if (!options || options.useGlobalScope !== false)
      gatherCompletions(global);
    forEach(keywords, maybeAdd);
  }
  return found;
}
